import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class EvidVidTypeService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('evid-vid-types', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/evid/services/evid-vid-type.service.ts